import React from 'react'

import classNames from 'classnames'

import { useHomePageRefresh } from '@/hooks/features/useHomePageRefresh'
import useMetaLandingPageBrandRefresh from '@/hooks/features/useMetaLandingPageBrandRefresh'
import { useRebrandingTreatment } from '@/hooks/features/useRebrandingRefresh'

import { CmsLink } from './CmsLink'
import styles from './Footer.module.scss'

interface MenuProps {
  menuHeading: string
  menuItems: Array<{ itemTitle: string; itemUrl: string; linkType: string }>
}

interface FooterMenuProps {
  menu: MenuProps
}

export const FooterMenu: React.FC<FooterMenuProps> = ({ menu }) => {
  const { isEnabled: isNewFonts } = useRebrandingTreatment()
  const { isTreatment } = useMetaLandingPageBrandRefresh()
  const { isTreatment: isHomePageRefreshTreatment } = useHomePageRefresh()
  return (
    <div
      className={classNames(styles.menu, {
        [styles.newFonts]:
          isNewFonts || isTreatment || isHomePageRefreshTreatment,
      })}
    >
      <div className={styles.menuHeading}>
        <div className={styles.menuHeadingText}>{menu.menuHeading}</div>
      </div>
      <nav aria-label="footer link menu">
        {menu.menuItems.map((item, idx) => (
          <div key={idx} className={styles.menuItem}>
            <div className={styles.menuItemText}>
              <CmsLink linkType={item.linkType} itemUrl={item.itemUrl}>
                {item.itemTitle}
              </CmsLink>
            </div>
          </div>
        ))}
      </nav>
    </div>
  )
}
